<template>
	<div ref="entryPanel" v-if="clientAttendanceArray &&
		this.$store.state.usermetas.data.length > 0 &&
		this.$store.state.users.data.length > 0
		" style="user-select: none" class="scrollable is-flex is-flex-direction-column" id="entryContainer">
		<div class="m-2">
			<b-datepicker style="text-align: center;" inline indicators="bars" :first-day-of-week="1"
				:events="calenderEvents" v-model="clickedDate" :unselectable-days-of-week="disabledDates"/>
		</div>
		<div class="pr-1" @click="stornoAttendance(activeAttendance)" v-for="(activeAttendance) in activeArray"
			:key="'active_' + activeAttendance.id">
			<div>
				<AttendanceLogEntriesData :attendance="activeAttendance"
					:style="{ 'background-color': activeAttendance.attributes.storno == true ? '#feecef' : '' }" />
			</div>
		</div>

		<div style="background-color:transparent;" class="entry-box-entry p-0 box mb-0 mt-1 mb-1">
			<div class="has-text-centered article has-darker-grey-color white-text p-3">
				Historie
			</div>
		</div>

		<div class="pr-1" @click="stornoAttendance(inactiveAttendance)"
			v-for="(inactiveAttendance, index) in inactiveArray" :key="'inactive_' + inactiveAttendance.id">
			<template v-if="(index < maxViewPortIndex && index >= maxViewPortIndex - 10)">
				<div>
					<AttendanceLogEntriesData :attendance="inactiveAttendance"
						:style="{ 'background-color': inactiveAttendance.attributes.storno == true ? '#E1C2C7' : '' }" />
				</div>
			</template>
		</div>
		<b-pagination class="p-0 mt-1 mb-1 ml-1 mr-1 pagination-dark" :total="total" v-model="current"
			:range-before="rangeBefore" :range-after="rangeAfter" :order="order" :size="size" :simple="isSimple"
			:rounded="isRounded" :per-page="perPage" :icon-prev="prevIcon" :icon-next="nextIcon"
			aria-next-label="Next page" aria-previous-label="Previous page" aria-page-label="Page"
			aria-current-label="Current page" :page-input="hasInput" :page-input-position="inputPosition"
			:debounce-page-input="inputDebounce" @change="onPageChange(current)">
		</b-pagination>
		<StornoAttendanceModal v-model="isStornoModalActive" :attendanceObject="focusedLog" />
		<CalendarEventModal v-model="showEventModal" :eventArray="eventDates" />
	</div>
</template>

<script>
import AttendanceLogEntriesData from "@/components/modules/attendance/AttendanceLogEntriesData.vue"
import StornoAttendanceModal from "../../modals/StornoAttendanceModal.vue";
import CalendarEventModal from "../../modals/CalendarEventModal.vue"
import { mapGetters } from "vuex";

Date.prototype.addDays = function (days) {
	var date = new Date(this.valueOf());
	date.setDate(date.getDate() + days);
	return date;
}

export default {
	name: "AttendanceLogEntries",
	components: { AttendanceLogEntriesData, StornoAttendanceModal, CalendarEventModal },
	data() {
		return {
			current: 1,
			perPage: 10,
			rangeBefore: 3,
			rangeAfter: 1,
			order: '',
			size: 'is-small',
			isSimple: false,
			isRounded: false,
			hasInput: false,
			prevIcon: 'chevron-left',
			nextIcon: 'chevron-right',
			inputPosition: '',
			inputDebounce: '',

			focusedLog: undefined,
			isStornoModalActive: false,
			maxViewPortIndex: 10,
			viewPortIncreaseIteration: 1,
			scrollPosition: 0,
			clickedDate: undefined,
			showEventModal: false,
			eventDates: [],
		};
	},
	beforeCreate() { },
	mounted() {
		this.onPageChange()
	},
	updated() { },
	watch: {
		focusedClient() {
			this.maxViewPortIndex = 10
			this.scrollPosition = 0
			this.viewPortIncreaseIteration = 1
		},
		clickedDate() {
			if(this.clickedDate){
				this.calenderEvents.forEach(element => {
					if(element.date.getTime() === this.clickedDate.getTime()){
						this.eventDates.push(element)
					}
				});
				if(this.eventDates.length >= 1){
					this.showEventModal = true
				}
			}
		},
		showEventModal(newVal) {
			if(!newVal){
				this.eventDates = [];
			}
		}
	},
	computed: {
		...mapGetters({
			focusedClient: "clients/getFocusedClient",
			clientAttendanceArray: "clientAttendance/getData",
		}),
		activeArray() {
			let retArray = []
			let currentDate = (new Date()).setHours(0, 0, 0, 0)
			this.clientAttendanceArray.forEach(element => {
				if (element.attributes.endDate >= currentDate) {
					retArray.push(element)
				}
			});
			return retArray
		},
		inactiveArray() {
			let retArray = []
			let currentDate = (new Date()).setHours(0, 0, 0, 0)
			this.clientAttendanceArray.forEach(element => {
				if (element.attributes.endDate < currentDate) {
					retArray.push(element)
				}
			});
			return retArray
		},
		total() {
			let retValue = this.inactiveArray.length ? this.inactiveArray.length : 0
			return retValue
		},
		
		disabledDates(){
			/* TODO: Für deaktivierte Tage muss ich mir erst eine Strategie überlegen.
			let limit = 6;
			let counter = 0;
			let dataArray = this.focusedClient.attributes.licenseDays
			let retArray = []
			while (counter <= limit){
				dataArray.includes(counter) ? "" : retArray.push(counter)
				counter = counter + 1
			}
			return retArray;
			*/
			return [];
		},
		calenderEvents() {
			let tempArray = [];
			this.activeArray.forEach(element => {
				if (!element.attributes.storno) {
					let startDate = element.attributes.startDate
					let stopDate = element.attributes.endDate
					let dateType = element.attributes.isPresence ? element.attributes.attendancePresence.attributes.name : element.attributes.attendanceAbsence.attributes.name
					let dateTypeFormatted = (dateType.replace(".", '')).replace(/\s/g, "")
					while (startDate <= stopDate) {
						tempArray.push({
							date: new Date(startDate),
							type: dateTypeFormatted
						})
						startDate = startDate.addDays(1)
					}
				}
			})
			return tempArray
		}
	},
	methods: {
		onPageChange() {
			this.maxViewPortIndex = 10 * this.current;
		},
		stornoAttendance(logObject,) {
			this.focusedLog = logObject
			this.isStornoModalActive = true
		},
	},
}
</script>

<style scoped>
::v-deep .skeleton-title {
	width: 30%;
	height: 1.15rem;
	margin-bottom: .7rem;
	border-radius: .125rem;
}

::v-deep .skeleton-author {
	width: 20%;
	height: .6rem;
	margin-bottom: .5rem;
	margin-top: .25rem;
	border-radius: .25rem;
}

.white-text {
	color: white;
}

.entry-box {
	margin-right: 0.5em;
	margin-left: 0.5em;
	cursor: pointer;
	padding-bottom: 15px;
}

.entry-box:hover {
	background-color: whitesmoke;
}

.scrollable {
	overflow: auto;
	height: 100%;
	width: 100%;
	padding-bottom: 1.5rem;
}

.article {
	width: 100%;
	border-radius: 0.5rem;
}

.entry-box-entry {
	margin-right: 0.5em;
	margin-left: 0.5em;
	padding-bottom: 15px;
	text-align: center;
}

@media (max-width: 1026px) {
	.scrollable {
		overflow: auto;
		height: 100%;
		width: 100%;
	}
}

@media (max-width: 769px) {

	.tabs:not(:last-child),
	.pagination:not(:last-child),
	.message:not(:last-child),
	.level:not(:last-child),
	.breadcrumb:not(:last-child),
	.block:not(:last-child),
	.title:not(:last-child),
	.subtitle:not(:last-child),
	.table-container:not(:last-child),
	.table:not(:last-child),
	.progress:not(:last-child),
	.progress-wrapper.is-not-native:not(:last-child),
	.notification:not(:last-child),
	.content:not(:last-child),
	.box:not(:last-child) {
		margin-bottom: 0;
	}

	.scrollable {
		height: 100%;
		width: 95vw;
	}

	.entry-box {
		display: flex;
		width: 96%;
	}
}

@media (max-width: 400px) {
	div.media-left {
		margin: 0.1em 0 0 0;
	}
}

@media (max-width: 450px) {
	.authorTagContainer {
		display: flex;
		flex-direction: row;
		align-items: start;
	}

	.iconContainer {
		justify-content: start !important;
		display: flex !important;
		flex-direction: row !important;
	}
}
</style>
